import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Clock, AlertCircle } from "lucide-react";

export default function PaypalReturn() {
  const [params] = useSearchParams();
  const orderId = params.get("token"); // PayPal returns ?token=ORDER_ID&PayerID=...
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!orderId) { setStatus("error"); return; }
    let cancelled = false;
    (async () => {
      try {
        const r = await api.post(`/checkout/paypal/capture/${orderId}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") setStatus("paid");
        else setStatus("error");
      } catch {
        if (!cancelled) setStatus("error");
      }
    })();
    return () => { cancelled = true; };
  }, [orderId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="paypal-return-page">
      {status === "loading" && (
        <>
          <Clock className="w-20 h-20 text-[#FACC15] mx-auto mb-6 animate-pulse" />
          <h1 className="text-4xl font-black tracking-tighter">Capture du paiement PayPal...</h1>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-20 h-20 text-[#7AC143] mx-auto mb-6" />
          <h1 className="text-4xl font-black tracking-tighter text-[#1A2E1A]">Merci pour votre commande !</h1>
          <p className="text-[#4B634B] mt-4">Votre paiement PayPal a été reçu avec succès.</p>
        </>
      )}
      {status === "error" && (
        <>
          <AlertCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-4xl font-black tracking-tighter">Paiement non confirmé</h1>
          <p className="text-[#4B634B] mt-4">Le paiement n'a pas pu être finalisé. Veuillez réessayer.</p>
        </>
      )}
      <Link to="/shop" className="inline-block mt-8 bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full px-7 py-3 font-semibold transition-colors">
        Continuer mes achats
      </Link>
    </div>
  );
}
